import { createFetch } from '@vueuse/core'
import { useMsal } from './msal'
import { isOfflineDevelopment } from '~/utils'

export async function getMockedUrl(url: string) {
  const resolvers = (await import('../mocks/api')).default

  if (url === '')
    return ''

  if (!Object.prototype.hasOwnProperty.call(resolvers, url))
    throw new Error(`No mock data for API URL ${url}`)

  const base64Url = `data:application/json;base64,${btoa(unescape(encodeURIComponent(JSON.stringify(resolvers[url as keyof typeof resolvers].data))))}`

  return base64Url
}

export const useFetch = createFetch({
  baseUrl: isOfflineDevelopment ? undefined : import.meta.env.VITE_APP_API_PREDICTION_SERVICE_HOST,
  options: {
    async beforeFetch({ options, url }) {
      const { accessToken } = isOfflineDevelopment ? { accessToken: 'offline-development' } : await useMsal().acquireApiToken()

      options.headers = {
        ...options.headers,
        Authorization: `Bearer ${accessToken}`,
      }

      return {
        options,
        url: isOfflineDevelopment ? await getMockedUrl(url) : url,
      }
    },
  },
  fetchOptions: {
    mode: 'cors',
  },
})
